export default function TerritoryView() {
  return (
    <iframe
      src="/territory.html"
      title="Territory"
      style={{
        width: '100%',
        height: '100vh',
        border: 0,
        display: 'block',
      }}
    />
  );
}
